import React from 'react';
import { Typography, Button } from '@vtblife/uikit';

import classname from '@search/classname/src';
import Image from '@search/vtbeco-frontend-core/view/common/components/Image';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';

// @ts-ignore
import noResult from '../static/noResult.url.svg';

import './style.css';

const cn = classname.bind(null, 'EmptyResult');

export const EmptyResult = ({
    isMobile = false,
    reset,
    goBaseProgram,
    shortBtns = false,
    scrollToSimilar
}: {
    isMobile?: boolean;
    shortBtns: boolean;
    reset: () => void;
    goBaseProgram: () => void;
    scrollToSimilar: () => void;
}) => {
    const staticPath = useStaticPathConfig();

    return (
        <div className={cn(null, { isMobile })}>
            <>
                <Image
                    width={isMobile ? 114 : 170}
                    height={isMobile ? 80 : 120}
                    url={`${staticPath}${noResult}`}
                    alt='Картинка предложений не найдено'
                />
                <Typography variant='secondary-alone' bold className={cn('title', { isMobile })}>
                    На таких условиях оформить ипотеку не&nbsp;получится.
                </Typography>
                <Typography variant='secondary-alone' className={cn('disclaimer', { isMobile })}>
                    Попробуйте выбрать другую программу, изменить первоначальный взнос
                    и&nbsp;срок кредита или подобрать квартиру дешевле
                </Typography>
            </>
            <div className={cn('btns', { isMobile })}>
                {! shortBtns && (<div style={{ maxWidth: 'min-content' }}>
                    <Button
                        variant='secondary'
                        size='xs'
                        onClick={goBaseProgram}
                    >
                        Выбрать стандартную программу
                    </Button>
                </div>)}
                <div style={{ maxWidth: 'min-content' }}>
                    <Button
                        variant='secondary'
                        size='xs'
                        onClick={reset}
                    >
                        Сбросить все настройки
                    </Button>
                </div>
                <div style={{ maxWidth: 'min-content' }}>
                    <Button
                        variant='secondary'
                        size='xs'
                        onClick={scrollToSimilar}
                    >
                        Посмотреть похожие квартиры
                    </Button>
                </div>
            </div>
        </div>
    );
};
